import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  actions?: React.ReactNode;
  className?: string;
  titleClassName?: string;
}

/**
 * 共通ページヘッダーコンポーネント
 * 各ページで共通のタイトル表示を提供
 */
const PageHeader: React.FC<PageHeaderProps> = ({ 
  title, 
  subtitle, 
  icon, 
  actions,
  className = '',
  titleClassName = 'zen-old-mincho-bold'
}) => {
  return (
    <div className={`d-flex justify-content-between align-items-center mb-4 ${className}`}>
      <div>
        <h3 className={`mb-1 ${titleClassName}`}>
          {icon && <i className={`${icon} me-2`}></i>}
          {title}
        </h3>
        {subtitle && (
          <p className="text-muted mb-0">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="d-flex align-items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader; 